import { GoogleOAuthProvider } from '@react-oauth/google';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import React, { Suspense, useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { MultiBackend } from 'react-dnd-multi-backend';
import { useLocation } from 'react-router-dom';
import ErrorBoundary, { ErrorSlate } from './components-v2/ErrorBoundary';
import HeaderV2 from './components-v2/Header';
import Page from './components-v2/Layout/Page';
import LoadingComponent from './components-v2/LoadingComponent';
import Routes from './components/Routes';
import './css/styles.css';
import './css/tailwind.pcss';
import { stripeKey } from './lib/constants';
import ThemedIntercomLauncher from './theme/ThemedIntercomLauncher';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Initialize Stripe promise outside component to avoid recreating on each render
const stripePromise = loadStripe(stripeKey || '');

const App: React.FC = () => {
  const { pathname } = useLocation();

  const hideHeader = pathname.includes('consultation');

  return (
    <Elements stripe={stripePromise}>
      <GoogleOAuthProvider clientId={process.env.RAZZLE_APP_GOOGLE_CLIENT_ID || ''}>
        <ScrollToTop />
        {!hideHeader && <HeaderV2 />}
        <ThemedIntercomLauncher />
        <DndProvider backend={MultiBackend} options={HTML5toTouch}>
          <ErrorBoundary
            fallback={
              <div className="container m-auto">
                <ErrorSlate message="Issue loading component" />
              </div>
            }
          >
            <Suspense
              fallback={
                <Page>
                  <LoadingComponent />
                </Page>
              }
            >
              <Routes />
            </Suspense>
          </ErrorBoundary>
        </DndProvider>
      </GoogleOAuthProvider>
    </Elements>
  );
};

export default App;
